var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-work-options"},_vm._l((_vm.packages),function(option){return _c('CustomWorkOption',{key:option.key,attrs:{"option":option},on:{"packageSelected":function($event){return _vm.packageSelected(option)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }